const isEnhancedLeaseAbstractionDeal = deal => deal?.deal_type === 'lease';

export default isEnhancedLeaseAbstractionDeal;
